import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function CommunityInfoPage() {
  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">
        <section className="community-section">
          <div className="container">
            <div className="community-showcase">
              <div className="community-icon-cluster">
                <span className="community-icon icon-1">💬</span>
                <span className="community-icon icon-2">👨‍🌾</span>
                <span className="community-icon icon-3">🤝</span>
                <span className="community-icon icon-4">🌾</span>
              </div>

              <div className="community-content">
                <h2>BoAI Community Discussion Group</h2>
                <h3 className="hindi-text">BoAI समुदाय चर्चा समूह</h3>

                <p className="community-description">
                  Join thousands of farmers sharing knowledge, experiences, and success stories.
                  Ask questions, get answers, and grow together!
                </p>
                <p className="community-description-hi">
                  हजारों किसानों के साथ जुड़ें जो ज्ञान, अनुभव और सफलता की कहानियां साझा कर रहे हैं।
                  प्रश्न पूछें, उत्तर पाएं और साथ मिलकर बढ़ें!
                </p>

                <div className="community-features">
                  <div className="community-feature-item">
                    <div className="feature-icon">🧵</div>
                    <div className="feature-text">
                      <h4>Discussion Topics</h4>
                      <p>Soil health, pest control, irrigation & more</p>
                    </div>
                  </div>
                  <div className="community-feature-item">
                    <div className="feature-icon">💡</div>
                    <div className="feature-text">
                      <h4>Expert Tips</h4>
                      <p>Learn from experienced farmers</p>
                    </div>
                  </div>
                  <div className="community-feature-item">
                    <div className="feature-icon">🌐</div>
                    <div className="feature-text">
                      <h4>Bilingual Support</h4>
                      <p>Discuss in Hindi or English</p>
                    </div>
                  </div>
                </div>

                <button className="btn-primary community-cta" onClick={() => navigate('/auth')}>
                  Join BoAI Community Forum
                </button>
              </div>

              <div className="community-preview">
                <div className="preview-card">
                  <div className="preview-header">
                    <span className="preview-emoji">🌾</span>
                    <div>
                      <h5>Best Practices for Soil Health</h5>
                      <p className="preview-meta">Rajesh - 3h ago - 12 comments</p>
                    </div>
                  </div>
                  <p className="preview-excerpt">"Share your experiences with crop rotation and organic manure..."</p>
                </div>
                <div className="preview-card">
                  <div className="preview-header">
                    <span className="preview-emoji">💧</span>
                    <div>
                      <h5>Drip Irrigation Tips</h5>
                      <p className="preview-meta">Priya - 5h ago - 8 comments</p>
                    </div>
                  </div>
                  <p className="preview-excerpt">"How drip irrigation helped me save 40% water..."</p>
                </div>
                <div className="preview-card">
                  <div className="preview-header">
                    <span className="preview-emoji">🐛</span>
                    <div>
                      <h5>Natural Pest Control</h5>
                      <p className="preview-meta">Amit - 1d ago - 15 comments</p>
                    </div>
                  </div>
                  <p className="preview-excerpt">"Effective organic methods to control pests without chemicals..."</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
